import { defineStore } from "pinia"
import { PlaylistType } from "~/types/schema"
import http from "~/services/http"

interface IPlaylistAdd extends IErrorAndSuccessCallbacks {
  playlistSlug: string
  identifier: string
  type: string
}

interface IPlaylistCreate extends IErrorAndSuccessCallbacks {
  name: string
}

interface IPlaylistDelete extends IErrorAndSuccessCallbacks {
  slug: string
}

const usePlaylistsStore = defineStore("playlistsStore", {
  state: () => ({
    playlists: [] as PlaylistType[],
  }),

  actions: {
    deletePlaylist({ slug, successCallback, errorCallback }: IPlaylistDelete) {
      http.delete({
        url: `v1/user/playlists/${slug}`,
        successCallback: (context) => {
          this.fetchPlaylists({})
          successCallback && successCallback(context)
        },
        errorCallback: (context) => {
          errorCallback && errorCallback(context)
        },
      })
    },

    fetchPlaylists({ successCallback, errorCallback }: IErrorAndSuccessCallbacks) {
      http.get({
        url: "v1/user/playlists",
        successCallback: (context) => {
          this.playlists = context.response._data.playlists
          successCallback && successCallback(context.response._data)
        },
        errorCallback: (context) => {
          errorCallback && errorCallback(context)
        },
      })
    },

    createNewPlaylist({ name, successCallback, errorCallback }: IPlaylistCreate) {
      http.post({
        url: "v1/user/playlists",
        body: {
          name,
          module: "normal",
        },
        successCallback: (context) => {
          this.playlists.push(context.response._data.playlist)
          successCallback && successCallback(context)
        },
        errorCallback: (context) => {
          errorCallback && errorCallback(context)
        },
      })
    },

    addToPlaylist({ playlistSlug, identifier, type, successCallback, errorCallback }: IPlaylistAdd) {
      http.post({
        url: `v1/user/playlists/${playlistSlug}/items`,
        body: {
          identifier,
          type,
        },
        successCallback: (context) => {
          successCallback && successCallback(context)
        },
        errorCallback: (context) => {
          errorCallback && errorCallback(context)
        },
      })
    },
  },
})

export default usePlaylistsStore
